export default "__VITE_ASSET__Cdp$XuPP__"